import React, { useEffect, useState } from 'react';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

import { Container, Menu } from './styles';

import logo from '~/assets/logos/full-logo-black.svg';

const Header: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const [active, setActive] = useState(false);
  const [pageId, setPageId] = useState('inicio');
  const [whiteMenu, setWhiteMenu] = useState(false);

  useEffect(() => {
    setActive(false);
    if (location.hash) {
      setPageId(location.hash.replace('#', ''));
      history.push(process.env.PUBLIC_URL);
    }
  }, [history, location.hash]);

  useEffect(() => {
    setTimeout(() => {
      scroller.scrollTo(pageId, {
        smooth: 'easeInOutQuart',
        offset: -100,
      });
    }, 100);
    setActive(false);
  }, [pageId]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      const menu = document.getElementById('menu');
      const hero = document.getElementById('inicio');
      if (menu && hero) {
        const { height } = hero.getBoundingClientRect();
        setWhiteMenu(window.scrollY >= height - menu.offsetHeight);
      }
    });
  }, []);

  // const LinkComponent = useMemo<any>(() => {
  //   if (location.pathname !== '/') {
  //     return NavLink;
  //   }

  //   return AnchorLink;
  // }, [location.pathname]);

  return (
    <>
      <Container active={active} className="menu-header" whiteMenu={whiteMenu}>
        <div
          id="menu"
          className="container-fluid py-3 py-lg-0 menu-fix d-lg-flex align-items-center"
        >
          <div className="row w-lg-100">
            <div className="col-12">
              <div className="container">
                <div className="row">
                  <div className="col-12 d-flex justify-content-between align-items-center text-center">
                    <div>
                      <NavLink to="/">
                        <img src={logo} alt="logo" />
                      </NavLink>
                    </div>
                    <Menu active={active} whiteMenu={whiteMenu}>
                      <button
                        type="button"
                        className="bg-transparent d-lg-none border-0 mx-3"
                        onClick={() => setActive(!active)}
                      >
                        <span />
                        <span />
                        <span />
                      </button>
                      <div className="menu-group active">
                        <div className="menu d-flex flex-column flex-lg-row justify-content-center">
                          {/* <LinkComponent
                            href="#inicio"
                            to={`${process.env.PUBLIC_URL}/`}
                            offset={100}
                            className={`btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center ${
                              pageId === 'inicio' ? 'active' : ''
                            }`}
                            onClick={() => setPageId('inicio')}
                            exact
                          >
                            Inicio
                          </LinkComponent>
                          <LinkComponent
                            href="#quem-somos"
                            to={`${process.env.PUBLIC_URL}/#quem-somos`}
                            offset={95}
                            className={`btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center ${
                              pageId === 'avisos' ? 'active' : ''
                            }`}
                            onClick={() => setPageId('quem-somos')}
                            exact
                          >
                            Quem somos
                          </LinkComponent>
                          <NavLink
                            to={`${process.env.PUBLIC_URL}/projetos`}
                            className="btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center"
                            activeClassName="active"
                            onClick={() => setPageId('projetos')}
                            exact
                          >
                            Projetos
                          </NavLink>
                          <LinkComponent
                            href="#solucoes"
                            to={`${process.env.PUBLIC_URL}/#solucoes`}
                            offset={95}
                            className={`btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center ${
                              pageId === 'avisos' ? 'active' : ''
                            }`}
                            onClick={() => setPageId('solucoes')}
                            exact
                          >
                            Soluções
                          </LinkComponent>
                          <NavLink
                            to={`${process.env.PUBLIC_URL}/contato`}
                            className="btn-menu h5 mb-4 mb-lg-0 mx-4 d-flex justify-content-center align-items-center"
                            activeClassName="active"
                            onClick={() => setPageId('contato')}
                            exact
                          >
                            Contato
                          </NavLink> */}
                          <Link
                            to={`${process.env.PUBLIC_URL}/quero-um-projeto/sobre-seu-projeto/que-tipo-de-projeto-voce-deseja`}
                            className="btn btn-budget py-2 px-4 d-block d-lg-none w-75 mx-auto mt-5"
                          >
                            Solicitar orçamento
                          </Link>
                        </div>
                      </div>
                    </Menu>
                    <a
                      href="https://api.whatsapp.com/send?phone=5511913096161&text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento."
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-budget py-2 px-4 d-none d-lg-block"
                    >
                      Solicitar orçamento
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Header;
